<template>
  <div class="footer">
    <div class="wrap">
      <div class="contact">
        <div class="desc">
          <p class="title">浅阅科技</p>
          <p>地址：浙江省宁波市鄞州区首南街道都市工业园区明光路298号2555室</p>
        </div>
      </div>
      <div class="copyright">
        <span>版权所有@浅阅科技</span>
        <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2026057991号</a>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33021202004435" rel="noreferrer" target="_blank"><img src="@/assets/beian.png" alt="">浙公网安备33021202004435号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeFooter'
}
</script>

<style lang="scss" scoped>
a{
  &:hover{
    text-decoration: underline;
  }
}

.footer{
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;
  z-index: 0;
  background-color: $themeBarColor;
  color: $themeColor;
}
.contact{
  display: flex;
  padding: 80px 0 10px;
  justify-content: space-between;
  align-items: center;
  .desc{
    p{
      padding: 10px 0;
      line-height: 22px;
      font-size: 14px;
      &.title{
        font-size: 18px;
      }
    }
  }
}
.copyright{
  border-top: 1px solid rgba(#fff, .4);
  padding: 25px 0;
  line-height: 20px;
  font-size: 12px;
  img{
    width: 16px;
    height: 16px;
    margin-right: 5px;
    vertical-align: middle;
  }
}
@media screen and (min-width: 750px){
  .contact{
    .desc{
      position: relative;
      padding-left: 30px;
      &:before{
        position: absolute;
        top: 13px;
        left: 0;
        bottom: 14px;
        width: 2px;
        background-color: rgba(#fff, 1);
        content: '';
      }
    }
  }
}
@media screen and (max-width: 750px){
  .contact{
    flex-direction: column;
    .desc{
      text-align: center;
    }
  }
  .copyright{
    text-align: center;
  }
}
@media screen and (min-width: 500px){
  .copyright{
    a{
      margin-left: 2em;
    }
  }
}
@media screen and (max-width: 500px){
  .copyright{
    span, a{
      display: block;
    }
  }
}
</style>
